import { authenticatedFetchJson } from "@/services/utils/authenticatedFetch";

interface MultiadapterCredentials {
  username: string;
  password: string;
  apiUrl: string;
}

export async function getMultiadapterCredentials(): Promise<MultiadapterCredentials> {
  try {
    const data = await authenticatedFetchJson<MultiadapterCredentials>("/api/multiadapter-credentials", {
      method: "GET",
    });

    return {
      username: data.username || "",
      password: data.password || "",
      apiUrl: data.apiUrl || ""
    };
  } catch (error) {
    console.error("Error fetching Multiadapter credentials:", error);
    return { username: "", password: "", apiUrl: "" };
  }
}
